import { Context } from '@nuxt/types';

const mapHostToEnvironment = (host: string): string => {
  const matches = host.match(/(.+)\.attelu\.com/);
  if (matches == null) {
    return 'production'; // 上記のホストにマッチしないときにはプロダクションとして扱う。ホストが変わったときにエラー検知が動かなくなることを避けるため
  }
  const environment = matches[1];
  if (environment == null) {
    return 'production'; // 上記のホストにマッチしないときにはプロダクションとして扱う。ホストが変わったときにエラー検知が動かなくなることを避けるため
  }
  switch (environment) {
    case 'app':
      return 'production';
    case 'app-stg':
      return 'staging';
    default:
      return environment;
  }
};

export default function ({ store, app }: Context): void {
  app.$sentry.configureScope((scope: any) => {
    scope.setUser({ id: store.state.user.profile.userId });
    scope.addEventProcessor(
      (event: any) =>
        new Promise((resolve) =>
          resolve({
            ...event,
            environment: mapHostToEnvironment(window.location.host)
          })
        )
    );
  });
}
